import React from "react";
import { ColumnsType } from "antd/es/table";
import { Button, Divider, Dropdown, Form, Input, MenuProps, Space } from "antd";
import { MicroscopeIconSVG, SaveIconSVG } from "assets";
import "./DetailInfo.scss";
import moment from "moment";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnProps } from "types/models";
import { ColumnsEdit } from "types/models/column-table-edit";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;

const columnsTableAnalysisList: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "4%",
    align: "center",
    render: (text, record, index) => index + 1,
    show: true,
  },
  {
    title: "Mã xét nghiệm",
    dataIndex: "id",
    key: "id",
    align: "left",
    show: true,
    width: "3%",
  },
  {
    title: "Mã bệnh phẩm",
    dataIndex: "maBenhPham",
    key: "maBenhPham",
    align: "left",
    show: true,
  },
  {
    title: "Tên dịch vụ xét nghiệm",
    dataIndex: "tenDichVuXN",
    key: "tenDichVuXN",
    align: "left",
    show: true,
  },
  {
    title: "TG lấy mẫu",
    dataIndex: "thoiGianLayMau",
    key: "thoiGianLayMau",
    align: "center",
    show: true,
  },
  {
    title: "TG trả kết quả",
    dataIndex: "thoiGianTraKetQua",
    key: "thoiGianTraKetQua",
    align: "right",
    // render(value, record, index) {
    //   return (
    //     <div>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</div>
    //   );
    // },
    show: true,
  },
  {
    title: "Nhân viên lấy mẫu",
    dataIndex: "nhanVienLayMau",
    key: "nhanVienLayMau",
    align: "left",
    show: true,
  },
  {
    title: "Máy xét nghiệm",
    dataIndex: "mayXetNghiem",
    key: "mayXetNghiem",
    align: "left",
    show: true,
  },
  {
    title: "Người nhập kết quả",
    dataIndex: "nguoiNhapKetQua",
    key: "nguoiNhapKetQua",
    align: "left",
    show: true,
  },
  {
    title: "Người duyệt kết quả",
    dataIndex: "nguoiDuyetKetQua",
    key: "nguoiDuyetKetQua",
    align: "left",
    show: true,
  },
  {
    title: "Thời gian duyệt",
    dataIndex: "thoiGianDuyetKetQua",
    key: "thoiGianDuyetKetQua",
    align: "right",
    show: true,
  },
  {
    title: "Phương pháp",
    dataIndex: "phươngPhap",
    key: "phươngPhap",
    align: "center",
    show: true,
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    key: "ghiChu",
    align: "center",
    show: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
    show: true,
    fixed: "right",
    with: "3%",
  },
];

export { columnsTableAnalysisList };
